<script>



export default {
  props: {
    value: true,
    pc: {
      type: String,
      default: 'tabs',
    },
    sp: {
      type: String,
      default: 'accordion',
    },
  },



  data() {
    return {
      lazyTabSelected: this.value,
    }
  },



  computed: {
    currentType() { return this[this.$store.getters['mq/group']] },
    classes() {
      return {
        'dn-switch-tabs': true,
        [`dn-switch-tabs--${this.currentType}`]: true,
      }
    },
    tabSelected: {
      get() { return this.lazyTabSelected },
      set(val) {
        if (val === this.lazyTabSelected) return;
        this.lazyTabSelected = val;
        this.$emit('input', val);
      },
    },
  },



  watch: {
    value(val) {
      this.lazyTabSelected = val;
    },
  },



  methods: {
    genTabs(items) {
      const $tabs = this.$createElement('dn-tabs', {
        props: {
          value: this.tabSelected,
        },
        on: {
          input: e => {
            this.tabSelected = e;
          },
        },
      }, [
        this.$createElement('dn-tabs-bar', {slot: 'activators'}, items.map(item => {
          return this.$createElement('dn-tabs-item', {
            props: {
              href: `#${item.id}`,
            },
          }, item.$label.children);
        })),

        ...items.map(item => {
          const $accordion = this.$createElement('dn-accordion', {}, [
            this.$createElement('template', {slot: 'trigger'}, item.$label.children),
            this.$createElement('template', {slot: 'body'}, item.$content.children),
          ]);

          return this.$createElement('dn-tabs-content', {
            props: {
              id: item.id,
            },
          }, [$accordion]);
        }),
      ]);
      return [$tabs];
    },
    genAccordions(items) {
      return items.map(item => {
        return this.$createElement('dn-accordion', {}, [
          this.$createElement('template', {slot: 'trigger'}, item.$label.children),
          this.$createElement('template', {slot: 'body'}, item.$content.children),
        ]);
      });
    },
  },

  render(h) {
    const $wrapper = h('div', {
      'class': this.classes,
    });

    const items = [];

    const $items = this.$slots.default.filter($slot => $slot.tag === 'dn-switch-tabs-item');
    $items.forEach($item => {
      const item = {
        $el: $item,
        id : $item.data.attrs.id,
      };
      item.$label   = $item.children.find($child => $child.tag === 'dn-switch-tabs-label');
      item.$content = $item.children.find($child => $child.tag === 'dn-switch-tabs-content');
      items.push(item);
    });

    $wrapper.children = this.genTabs(items);
    return $wrapper;
  },
}
</script>


// WEBPACK FOOTER //
// SwitchTabs.vue?954f1dfa